import {
  removeLocalStorageItem,
  setLocalStorageItem,
  retrieveLocalStorageItem,
} from 'utils/localStorage.js'

import {
  CLIENT_OVERVIEW,
  CLIENT_DOCUMENTS,
  CLIENT_LOGIN,
} from 'actionTypes/client/routing'

import {
  ERROR_PAGE
} from 'actionTypes/routing'

const invalidRedirectTypes = [ERROR_PAGE, CLIENT_LOGIN]

export const defaultRedirectLocations = {
  client: {
    type: CLIENT_OVERVIEW
  },
  prospect: {
    type: CLIENT_DOCUMENTS,
    payload: {
      documentListType: 'my-uploads'
    }
  },
}
export const removeRedirectLocation = () => removeLocalStorageItem('redirectLocation', 'local')
export const setRedirectLocation = (location) => {
  const { type } = location

  if (!invalidRedirectTypes.includes(type)) {
    return setLocalStorageItem('redirectLocation', JSON.stringify(location), 'local')
  }
}
export const getRedirectLocation = () => JSON.parse(retrieveLocalStorageItem('redirectLocation', 'local'))



// WEBPACK FOOTER //
// ./src/utils/Client/redirects.js